import React from 'react';
import { Button, Divider, Avatar } from 'antd';
import i18n from 'i18next';
import LikeIcon from '../../../assets/images/png/like.png';
import { GlobalModalHandler, GlobalModalClose } from '../../layout/GlobalModal';
import { FaPhone } from 'react-icons/fa';
import { UserDetails } from '../../../store/orders/types';

interface AcceptedOrderProps {
  userdetails: UserDetails;
  history: any;
}

export const OrderAccepted = ({ userdetails, history }: AcceptedOrderProps) => {
  const img =
    'https://gw.alipayobjects.com/zos/rmsportal/JiqGstEfoWAOHiTxclqi.png';
  const handleContinueButton = () => {
    GlobalModalClose();
  };
  const handleClickName = () => {
    history.push({
      pathname: '../chat/:',
      state: { user: userdetails, chatid: '' },
    });
    GlobalModalClose();
  };
  return (
    <div>
      <div className="modal-content-wrapper">
        <div className="modal-content-icon">
          <img src={LikeIcon} alt="modal-content-icon" />
        </div>
        <div className="modal-content-description">
          <span>{i18n.t('ORDER_ACCEPTED')}</span>
        </div>
      </div>
      <Divider />
      <div className="modal-content-wrapper order-accepted-container">
        <div>
          <Avatar src={userdetails.image} size="small" />
        </div>
        <div
          className="accepted-cook-details"
          onClick={handleClickName}
          style={{ cursor: 'pointer' }}
        >
          <span className="cook-details-name">{userdetails.firstName}</span>
        </div>
        <div className="accepted-cook-contact">
          <div>
            <FaPhone size={14} color="#27aae1" />
            <span>{userdetails.phone}</span>
          </div>
        </div>
      </div>
      <div className="button-container modal-map-buttons-container">
        <div>
          <Button
            block
            shape="round"
            className="continue-button continue-button-primary"
            onClick={handleContinueButton}
          >
            <span className="continue-button-text">{i18n.t('Continue')}</span>
          </Button>
        </div>
      </div>
    </div>
  );
};

export const orderAcceptedModalHandler = (
  userdetails: UserDetails,
  history: any
) => {
  GlobalModalHandler({
    content: <OrderAccepted userdetails={userdetails} history={history} />,
  });
};
